import { createContext } from 'react';

export const mapCtx = createContext<google.maps.Map | null>(null);
